import React from 'react';
import { DiamondIcon } from './Icons';
export const UniqueMechanism = () => {
  return <section className="w-full bg-light py-8 md:py-12 px-4 md:px-6" data-id="element-205">
      <div className="max-w-[720px] mx-auto" data-id="element-206">
        <h2 className="font-playfair text-[28px] md:text-[42px] text-primary text-center mb-6" data-id="element-207">
          The Discovery That Changes Everything
        </h2>

        <div className="font-lato text-[16px] md:text-[17px] text-body leading-[1.8]" data-id="element-208">
          <p className="mb-5" data-id="element-209">
            The reason you keep feeling this way is not because something is
            broken in you. It's because nobody explained to you how female
            hormonal balance actually works.
          </p>
          <p className="mb-5" data-id="element-210">
            Functional science has discovered something conventional medicine
            ignores:
          </p>
        </div>

        <div className="bg-white border-[2px] border-medium rounded-[16px] py-8 px-6 md:py-8 md:px-10 my-8 max-w-[640px] mx-auto" data-id="element-211">
          <p className="font-playfair italic text-[20px] md:text-[22px] text-primary text-center m-0" data-id="element-212">
            "Your hormones don't fall out of balance on their own. They are
            disrupted by the chaos surrounding your system."
          </p>
        </div>

        <div className="font-lato text-[16px] md:text-[17px] text-body leading-[1.8]" data-id="element-213">
          <p className="mb-5" data-id="element-214">
            Inflammation from processed foods. Xenoestrogens from plastics and
            cosmetics. Chronic cortisol from digital stress. Permeable gut that
            recirculates used estrogens.
          </p>
          <p className="mb-5" data-id="element-215">
            When you eliminate that noise, your body knows exactly how to return
            to balance.
          </p>
          <p className="mb-5" data-id="element-216">We call this Hormonal Minimalism.</p>
          <p className="mb-5" data-id="element-217">
            It is not about adding more. It is about eliminating what
            interferes.
          </p>
        </div>

        <div className="bg-white border border-accent rounded-[16px] p-6 md:p-8 mt-8" data-id="element-218">
          <h3 className="font-playfair text-[24px] md:text-[28px] text-primary mb-6" data-id="element-219">
            The Liver-Gut Axis
          </h3>

          <div className="flex flex-col" data-id="element-220">
            <div className="flex items-start gap-3 py-3 border-b border-[#F0EBF8]" data-id="element-221">
              <div className="mt-1 flex-shrink-0" data-id="element-222">
                <DiamondIcon color="#957DAD" size={16} data-id="element-223" />
              </div>
              <p className="font-lato text-[16px] text-body m-0" data-id="element-224">
                The LIVER deactivates used estrogens
              </p>
            </div>
            <div className="flex items-start gap-3 py-3 border-b border-[#F0EBF8]" data-id="element-225">
              <div className="mt-1 flex-shrink-0" data-id="element-226">
                <DiamondIcon color="#957DAD" size={16} data-id="element-227" />
              </div>
              <p className="font-lato text-[16px] text-body m-0" data-id="element-228">
                The GUT eliminates them from the body
              </p>
            </div>
            <div className="flex items-start gap-3 py-3 border-b border-[#F0EBF8]" data-id="element-229">
              <div className="mt-1 flex-shrink-0" data-id="element-230">
                <DiamondIcon color="#957DAD" size={16} data-id="element-231" />
              </div>
              <p className="font-lato text-[16px] text-body m-0" data-id="element-232">
                When this system fails, estrogens RECYCLE and create cascading
                symptoms
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};